<template>
  <div class="page">
    <div class="page-container">
      <!--        网站首页-->
      <div class="page-tab">
        <img src="../assets/image/page/icon.png"/>
        <div @click="goHome()" class="page-tab-text">网站首页 >></div>
        <span>新闻动态</span>
      </div>
      <!--        文字标题部分-->
      <div class="page-content">
        <div class="page-title">极欧科技助力工商银行——开拓获客营销新模式</div>
        <div class="page-time">
          <div class="page-line" style="margin-right: 20px"></div>
          2021-01-18 14:54
          <span>编辑：xql</span>
          <div class="page-line" style="margin-left: 20px"></div>
        </div>
      </div>
      <!--        文字内容部分-->
      <div class="page-product">
        <!--          第一部分-->
        <div class="page-one">
          <div class="page-text">
            众所周知，营销活动的最核心元素之一就是获客，在移动互联网的普及下，我们发现传统获客方式总是缺乏灵活性，而且成本居高不下，尤其是对于银行业来说，以网点为中心开展的获客营销活动往往准备期长，跟进工作繁琐且效率较低。所以，为更好完成企业营销目标，开拓新的获客方式非常重要，而选择新媒体渠道作为获客主要来源，正是越来越多企业的共同选择。
          </div>
          <div class="page-text">
            因此，极欧科技结合了工商银行某分行实际需求，以微信端和手机银行为主要渠道，打造了本次获客新模式，依托银行已有粉丝群体和手机银行平台，结合微信渠道的社交属性和展示特点，开展此次营销活动。
          </div>
        </div>
        <!--                     第一部分-->
        <div class="page-one">
          <div class="page-icon">
            <span>1、活动理念</span>
          </div>
          <div class="page-text page-two-text">
            以获客为中心，通过营销活动选题以及内容，挖掘客户的需求与好奇心，并结合技术手段，实现客户舆情监控、信息抓取和实时的活动反馈，达到企业吸纳转化新客户，细分老客户的活动目的。
          </div>
        </div>
        <!--                        第二部分-->
        <div class="page-one">
          <div class="page-icon">
            <span>2、模式特点</span>
          </div>
          <div class="page-title">
            01、深化品牌认知：
          </div>
          <div class="page-text ">
            品牌的价值对企业的重要性不言而喻，如何通过品牌去影响目标用户决策，是很多企业一直关注的重点，但是单纯通过广告传播打造品牌并不能有效的转化用户，其实是非常低效的获客方式。所以，本次获客方案选择了既有传播性内容、奖励机制，而且兼顾品牌内涵塑造的活动，在增强客户对品牌的认知的同时，以一个较低的成本，完成用户的引流转化。
          </div>
          <div class="page-title ">
            02、发挥渠道特性：
          </div>
          <div class="page-text">
            回顾以往银行业虽然占据多种渠道：网点、手机银行app、自媒体、网站等等，但是各个渠道之间都是各自为政，并未形成良性循环。很多活动都需要进入到网点，才能获取到用户。受限于地域、时间，从现在来看是一种成本较高的获客方式。加之互联网时代下的行业竞争更加剧烈，导致传统方式获得用户是非常容易流失的，所以，我们的获客模式，选择了多渠道推广的统一规划，将不同渠道的特点发挥起来，丰富活动场景，从流量端引入业务端，实现了用户较好的留存效果和新老用户的参与程度。
          </div>
          <div class="page-title">
            03、建立新营销体系：
          </div>
          <div class="page-text">
            新营销体系是基于传统营销的全面升级，不同于旧体系以产品为中心，新营销体系将围绕客户为中心，构建用户--产品--交易--品牌的全新逻辑，更明确了用户创造价值的观念。从决策层面，建立起更高效的营销方式；从实际执行上，可以帮助企业制定更加科学的营销方案。
          </div>
          <div class="page-title">
            04、打造智能客服系统:
          </div>
          <div class="page-text">
            通过极欧技术平台，为客户打造一个集获取信息，客户服务、用户反馈、活动进度监管、人员管理等等职能为一体的服务平台。帮助企业更清晰的了解活动情况，完成后续获客活动的优化与完善。
          </div>
        </div>
        <!--                        第三部分-->
        <div class="page-one">
          <div class="page-icon">
            <span>3、应用效果</span>
          </div>
          <div class="page-title">
            01、对客户的价值
          </div>
          <div class="page-text ">
            让客户在短时间内对人、产品、企业有全方位的了解，感受专属专业的价值服务。
          </div>
          <div class="page-title">
            02、对业务的价值
          </div>
          <div class="page-text ">
            高效获客，精准判断客户意向，智能跟进客户，提升工作效率，提高转化率。
          </div>
          <div class="page-title">
            03、对企业的价值
          </div>
          <div class="page-text ">
            打造私域流量池，高效管理团队，提升运营管理效率，提升单客户价值。
          </div>
          <div class="page-text ">
            天津思奇科技股份有限公司为国家高新技术企业，北京极欧科技有限公司为其子公司，集团公司成立于2012年，公司旨在为银行业、中石化等拥有大批C端用户的传统企业，提供金融科技全产业链综合服务，通过多年积累深耕的行业信息化系统建设经验，为客户提供系统规划、方案实施、部署运维、业务运营、用户管理与广告投放等形态多样的一站式金融科技服务，从前端到后端，全面满足客户数字化转型的需求。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageThree",
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
.page {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .page-container {
    margin-bottom: 60px;
    position: relative;
    margin-top: -150px;
    width: 60%;
    background: #FFFFFF;
    padding: 100px 60px 100px 60px;
    box-shadow: 0px 20px 73px 0px rgba(102, 153, 204, 0.2);

    .page-tab {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }

      .page-tab-text {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

      span {
        color: #2368DD;
        margin-left: 10px;
      }
    }

    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-title {
        padding-top: 100px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        opacity: 0.9;
      }

      .page-time {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 45px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;

        span {
          margin-left: 40px;
        }

        .page-line {
          width: 20%;
          height: 1px;
          background: #000000;
          opacity: 0.2;
        }
      }

    }

    .page-product {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-img {
        margin-top: 50px;
      }

      .page-icon {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #5A5A5A;

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color:#5A5A5A;
          line-height: 20px;
          opacity: 0.8;
        }
      }

      .page-text {
        margin-top: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: #808080;
        line-height: 20px;
        text-indent: 30px;
        opacity: 0.7;
      }

      .page-title {
        text-indent: 30px;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #5A5A5A;
        line-height: 26px;
        //opacity: 0.7;
      }

      .page-two-text {
        margin-top: 25px;
        line-height: 30px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .page {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .page {
    .page-container {
      margin-top: -90px;
      padding: 50px 60px 100px 60px;

      .page-img {
        img {
          width: 260px;
          height: 144px;
        }
      }

      .page-content {
        .page-title {
          text-align: center;
          padding-top: 50px;
          font-size: 20px;
        }

        .page-time {
          .page-line {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

</style>
